import React, { useEffect } from "react";
import Routes from "./Routes";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const App = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { token } = useSelector((state) => state.auth);
  const [isInital, setIsinitial] = useState(false);

  useEffect(() => {
    if (token) {
      dispatch({
        type: "BOOKING_ASSIGNED",
        payload: {
          token: token,
          pageNumber: 1,
        },
      });
      dispatch({ type: "TOTAL_BOOKING_COUNT", payload: token });
      dispatch({ type: "AFFILIATE_DETAILS", payload: token });
    }
  }, [token, dispatch]);

  useEffect(() => {
    const affiliateEmail = localStorage.getItem("affiliateEmail");
    if (affiliateEmail && isInital === false) {
      dispatch({ type: "AUTH_ACCESS_TOKEN", payload: { affiliateEmail } });
      setIsinitial(true);
    }
  }, [isInital]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (token) {
  //       navigate("/ordermanage", { replace: true });
  //     } else {
  //       navigate("/login", { replace: true });
  //     }
  //   }, 500);

  //   return () => clearTimeout(timer);
  // }, [token]);

  // if token is available then navigate to ordermanage page

  return (
    <div className="">
      <Routes />
    </div>
  );
};

export default App;
